import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { getActuatorList } from '../api'
import { ActuatorData } from '../models/smart-home.model'
import { usePortalQuery } from 'src/Libs/api'
import { getSmarthomeConfiguredState } from '../api/actuators.api'
import { useTypedSelector } from 'src/State/RootReducer'
import { isFlowTheme } from 'src/Libs/utils'

export const actuatorsQueryKey = (installationId: string, refresh: unknown) => ['actuators', installationId, refresh] as const

export const smarthomeConfiguredStateQueryKey = (installationId: string | undefined) => ['smarthome', 'module', 'configured', installationId] as const

export const useActuators = (installationId: string): [ActuatorData[] | undefined, boolean, boolean, () => void] => {
  const authFetch = useAuthFetchWithResponse()
  const refresh = useTypedSelector(state => state.apiView.refresh)

  const { data, isError, isLoading, refetch } = usePortalQuery<ActuatorData[]>({
    queryKey: actuatorsQueryKey(installationId, refresh),
    queryFn: () => getActuatorList(installationId, authFetch),
    enabled: !!installationId,
    staleTime: 0,
  })

  return [data ?? undefined, isLoading, isError, refetch]
}

/**
 * Get the status of the smarthome module to determine if the smarthome section is avaliable
 */
export const useSmarthomeModuleState = (installationId: string | undefined): boolean => {
  const authFetch = useAuthFetchWithResponse()

  const { data, isError } = usePortalQuery<boolean>({
    queryKey: smarthomeConfiguredStateQueryKey(installationId),
    queryFn: () => getSmarthomeConfiguredState(installationId!, authFetch),
    enabled: !!installationId && !isFlowTheme,
  })

  return !!data && !isError
}
